import SuperRepository from '../superRepository'

export default new (class BudgetRequestsLogRepository extends SuperRepository {
  baseUri() {
    return 'planned_budget_import_log'
  }
  downloadFile = id => this.httpClient().getFile(`${this.baseUri()}/${id}/get_file`)
  downloadWarningsFile = id => this.httpClient().getFile(`${this.baseUri()}/${id}/warnings_file`)
  exportBudgetRequestsLogToken = (data, params) =>
    this.reportHttpClient().postQuery('export/planned_budget_import_log/token', data, params)
})()
